export const fields = [
  {
    name: "Fullname",
    key: "fullName",
    type: "text",
    placeholder: "Enter Name",
    validation: "required",
  },
  {
    name: "Email Address",
    key: "email",
    type: "email",
    placeholder: "Enter Email Address",
    validation: "required",
  },
  {
    name: "Role",
    key: "role",
    type: "select",
    options: [
      "admin",
      "manager",
      "process_owner",
      "regional_manager",
      "route_manager",
      "investigator",
      "auditor",
    ],
    placeholder: "Select Role",
  },
  {
    name: "Send Welcome Email",
    key: "sendWelcomeEmail",
    type: "checkbox",
  },
  {
    name: "Require Training",
    key: "requireTraining",
    type: "checkbox",
  },
];
